import { create } from "zustand";
import type { Photo, Article } from "../types";
import { revokeRemovedPreviewUrls } from "../utils/previewUrls";
import { clearArticleDraft } from "../utils/draftStorage";

interface ArticleStore {
  article: Article;
  setPhotos: (photos: Photo[]) => void;
  setArticle: (article: Partial<Article>) => void;
  restoreArticle: (article: Article) => void;
  reset: () => void;
}

const initialState: Article = {
  articleTitle: undefined,
  sections: [],
  versionHistory: {},
  isLoading: false,
  error: undefined,
};

export const useArticleStore = create<ArticleStore>((set, get) => ({
  article: initialState,
  setPhotos: (photos) => {
    revokeRemovedPreviewUrls(get().article.sections, photos);
    set((state) => ({
      article: { ...state.article, sections: photos },
    }));
  },
  setArticle: (articleData) =>
    set((state) => ({
      article: { ...state.article, ...articleData },
    })),
  restoreArticle: (article) => {
    revokeRemovedPreviewUrls(get().article.sections, article.sections);
    set({ article });
  },
  reset: () => {
    revokeRemovedPreviewUrls(get().article.sections, []);
    set({ article: initialState });
    clearArticleDraft().catch((error: unknown) =>
      console.debug("Could not clear the local draft:", error),
    );
  },
}));
